const onIgnoreCache = () => {
	let version = "2.8.9";
	//console.log("Ignore cache: ",localStorage.getItem("version"));
	
	if(localStorage.getItem("version") != null){
		if(localStorage.getItem("version") != version){
			//console.log("Cache foi limpo!");
			localStorage.setItem("version", version);
			window.location.reload(true);
		}
		//else{
			//console.log("Cache não limpo!");
		//}
	}else{
		//console.log("Cache foi limpo!");
		localStorage.setItem("version", version);
		window.location.reload(true);
	}   
};
  
export default onIgnoreCache;



/** WEBPACK FOOTER **
 ** ./src/IgnoreCache.js
 **/